if ($('#app-reconciliation').length) {
    $(document).ready(function () {
        init_invoice_search_fields(false);
        init_invoice_search_fields_manual(false);
        $('#search_invoices').submit();
        $('#search_invoices_manual').submit();

        $('#nestable-menu').on('click', function (e) {
            var target = $(e.target),
                action = target.data('action');
            if (action === 'expand-all') {
                $('.dd').nestable('expandAll');
            }
            if (action === 'collapse-all') {
                $('.dd').nestable('collapseAll');
            }
            if (action === 'insert-line') {
                $('#newblinemodal').modal('show');
            }

            if (action === 're-match') {
                var conf = confirm("Are you sure to reset match?");
                if (conf) {
                    $("#espots").html("0");
                    $("#saveMachtModal").modal("hide");
                    $("#match-invoice-order").click();
                }
            }
        });

        $('#form_reset').bind('click', function(){
            init_invoice_search_fields(true);
        });

        $('#form_reset_manual').bind('click', function(){
            init_invoice_search_fields_manual(true);
        });

        $("#save-line").on('click', function (e) {
            if ($("#linedate").val() === "" || $("#linetime").val() === "" || $("#linesec").val() === "" || $("#linecost").val() === "")
                global_notification('error', "Complete all form fields...");
            else {
                var html = "";
                html += '<li spot-error="false" data-level="3" class="dd-item" data-id="b_newline" cost="' + $("#linecost").val() + '" day_of_week="' + $("#dayofweek").val() + '" run_date="' + $("#linedate").val() + '" time_of_day="' + $("#linetime").val() + '" type_spot_length="' + $("#linesec").val() + '">';
                html += '<div style="height: 30px;background-color: white;border: 1px solid darkred;color: black;" class="dd-handle">' + $("#dayofweek").val() + ' | ' + $("#linedate").val() + ' | ' + $("#linetime").val() + ' | ' + $("#linesec").val() + ' sec <div style="float: right">Make Good Spot</div></div>';
                html += '</li>';
                $('#no_matches').html(html + $('#no_matches').html());
                //var uspots = parseInt($("#uspots").html());
                //$("#uspots").html(uspots + 1);
                $('#newblinemodal').modal('hide');
                var nl = $("#count_newlines").html();
                $("#count_newlines").html(parseInt(nl) + 1);
            }
        });

        $("#del_new_spots_match").on('click', function (e) {
            var res = confirm("Are you sure to delete all new broadcast lines from Match List?");
            if (res) {
                $("#matches").find('li').each(function (i, opt) {

                    if ($(opt).attr('data-id') === 'b_newline') {
                        var ms = $("#mspots").html();
                        if (ms > 0)
                            $("#mspots").html(parseInt(ms) - 1);
                        var cl = $("#count_newlines").html();
                        if (cl > 0)
                            $("#count_newlines").html(parseInt(cl) - 1);
                        if ($(opt).attr('spot-error') === 'true') {
                            var se = $("#espots").html();
                            if (se > 0)
                                $("#espots").html(parseInt(se) - 1);
                        }
                        var max = $(opt).parent().parent();
                        var chlds = $(max).children();
                        var c = 0;
                        if (chlds.length === 4) {
                            c = $(chlds[2]).attr('scount');
                        } else {
                            c = $(chlds[0]).attr('scount');
                        }
                        max = $(max).attr('maxc');
                        if (c > max) {
                            var ow = $("#oweeks").html();
                            if (ow > 0)
                                $("#oweeks").html(parseInt(ow) - 1);
                        }
                        if (chlds.length === 4) {
                            if (parseInt(c) >= 1) {
                                $(chlds[2]).attr('scount', parseInt(c) - 1);
                                var week = $(chlds[2]).children();
                                var arr = $(week[0]).html().split('(');
                                var arr1 = arr[1].split('of');
                                var res = arr[0] + "(" + (parseInt(c) - 1) + " of " + arr1[1];
                                $(week).html(res);
                            }
                        } else {
                            c = $(chlds[0]).attr('scount');
                            $(chlds[0]).attr('scount', parseInt(c) - 1);
                            var week = $(chlds[0]).children();
                            var arr = $(week[0]).html().split('(');
                            if (typeof arr[1] !== 'undefined') {
                                console.log("second1");
                                var arr1 = arr[1].split('of');
                                var res = arr[0] + "(" + (parseInt(c) - 1) + " of " + arr1[1];
                                $(week).html(res);
                            }
                        }
                        var ls = $("#lspots").html();
                        if (ls > 0)
                            $("#lspots").html(parseInt(ls) + 1);
                        $(opt).remove();
                        global_notification('success', "New broadcast lines deleted...");
                    }
                });
            }
        });

        $("#del_new_spots_no_match").on('click', function (e) {
            var res = confirm("Are you sure to delete all new broadcast lines from Unmatched List?");
            if (res) {
                $("#no_matches").find('li').each(function (i, opt) {
                    if ($(opt).attr('data-id') === 'b_newline') {
                        var cl = $("#count_newlines").html();
                        if (cl > 0)
                            $("#count_newlines").html(parseInt(cl) - 1);
                        $(opt).remove();
                        global_notification('success', "New broadcast lines deleted...");
                    }
                });
            }
        });

        $("#linedate").on('change', function (e) {
            var date = moment($(this).val());
            var dow = date.day();
            $("#dayofweek").find('option').each(function (i, opt) {
                if (parseInt($(opt).attr('daynum')) == parseInt(dow))
                    $(opt).attr('selected', 'selected');
            });
        });

    });

    var init_invoice_search_fields = function (variable) {
        show_loader();

        $.ajax({
            type: 'GET',
            url: '/invoices/reconciliation/selects',
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('entre al succes');
                var orders = [];
                $.each(data.orders, function (index, value) {
                    orders.push({'id': value.id, 'text': value.reference_number});
                });

                var select = $('#order-number-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': orders,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var rec=[];
                $.each(data.rec, function (index, value) {
                    rec.push({'id': value.reconciliation_number, 'text': value.reconciliation_number});
                });

                var select = $('#reconciliation-number-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': rec,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var campaigns=[];
                console.log('longituddddd  ' + data.campaign.length);
                $.each(data.campaign, function (index, value) {
                    campaigns.push({'id': value.id, 'text': value.name});
                });

                var select = $('#invoice-campaign-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': campaigns,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });
            },
            error: function (xhr) {
                debug(xhr.responseText);
            }
        });


        $.ajax({
            type: 'GET',
            url: '/invoices/selects',
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('entre aqui-----');
                var numbers = [];
                $.each(data.data.numbers, function (index, value) {
                    numbers.push({'id': value.invoice_number, 'text': value.invoice_number});
                });

                var select = $('#invoice-number-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': numbers,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var advertisers = [];
                $.each(data.data.advertisers, function (index, value) {
                    advertisers.push({'id': value.advertiser_name, 'text': value.advertiser_name});
                });

                var select = $('#invoice-advertiser-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': advertisers,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var products = [];
                $.each(data.data.products, function (index, value) {
                    products.push({'id': value.product_name, 'text': value.product_name});
                });

                var select = $('#invoice-product-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': products,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var agencies = [];
                $.each(data.data.agencies, function (index, value) {
                    agencies.push({'id': value.name, 'text': value.name});
                });

                var select = $('#invoice-agencies-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': agencies,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var payees = [];
                $.each(data.data.payees, function (index, value) {
                    payees.push({'id': value.name, 'text': value.name});
                });

                var select = $('#invoice-payees-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': payees,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var stations = [];
                $.each(data.data.stations, function (index, value) {
                    stations.push({'id': value.name, 'text': value.name});
                });

                var select = $('#invoice-stations-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': stations,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var medias=[];
                medias.push({'id': 'TV', 'text': 'Television'});
                medias.push({'id': 'RADIO', 'text': 'Radio'});

                var select = $('#invoice-media-search');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': medias,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });


            },
            error: function (xhr) {
                debug(xhr.responseText);
            }


        });

        var input = $("#invoice-month-search");

        if (input.data('datepicker')) {
            input.datepicker('remove');
        }

        input.datepicker({
            format: "mm/yyyy",
            startView: "months",
            minViewMode: "months",
            autoclose: true,
            clearBtn: true,
            orientation: "bottom"
        });

        var input = $("#invoice-due-by-search");

        if (input.data('datepicker')) {
            input.datepicker('remove');
        }

        input.datepicker({
            format: "mm/dd/yyyy",
            autoclose: true,
            clearBtn: true,
            orientation: "bottom"
        });

        var input = $("#invoice-flight-dates-search");

        if (input.data('daterangepicker')) {
            input.data('daterangepicker').remove();
        }

        input.daterangepicker({
            "showWeekNumbers": true,
            "autoApply": true,
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');

        $('#invoice-created-at-search').daterangepicker({
            "showWeekNumbers": true,
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');

      
        if(variable===true)
            $('#search_invoices').submit();
        hide_loader();
    };

    var init_invoice_search_fields_manual = function (variable) {
        show_loader();

        $.ajax({
            type: 'GET',
            url: '/invoices/manual/reconciliation/selects',
            dataType: 'json',
            encode: true,
            success: function (data) {
                var orders = [];
                $.each(data.orders, function (index, value) {
                    orders.push({'id': value.id, 'text': value.reference_number});
                });

                var select = $('#order-number-search_manual');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': orders,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var rec=[];
                $.each(data.rec, function (index, value) {
                    if(value.rec_number !== null && value.rec_number !== "")
                        rec.push({'id': value.rec_number, 'text': value.rec_number});
                });

                var select = $('#reconciliation-number-search_manual');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': rec,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var campaigns=[];
                //console.log('longituddddd  ' + data.campaign.length);
                $.each(data.campaign, function (index, value) {
                    campaigns.push({'id': value.id, 'text': value.name});
                });

                var select = $('#invoice-campaign-search_manual');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': campaigns,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });
            },
            error: function (xhr) {
                debug(xhr.responseText);
            }
        });


        $.ajax({
            type: 'GET',
            url: '/invoices/manual/selects',
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('entre aqui-----');
                var numbers = [];
                $.each(data.data.numbers, function (index, value) {
                    numbers.push({'id': value.invoice_num, 'text': value.invoice_num});
                });

                var select = $('#invoice-number-search_manual');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': numbers,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var advertisers = [];
                $.each(data.data.advertisers, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name});
                });

                var select = $('#invoice-advertiser-search_manual');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': advertisers,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var stations = [];
                $.each(data.data.stations, function (index, value) {
                    stations.push({'id': value.id, 'text': value.name});
                });

                var select = $('#invoice-stations-search_manual');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': stations,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });

                var medias=[];
                medias.push({'id': 'TV', 'text': 'Television'});
                medias.push({'id': 'RADIO', 'text': 'Radio'});

                var select = $('#invoice-media-search_manual');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': medias,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select zero or more"
                });


            },
            error: function (xhr) {
                debug(xhr.responseText);
            }


        });

        var input = $("#invoice-month-search_manual");

        if (input.data('datepicker')) {
            input.datepicker('remove');
        }

        input.datepicker({
            format: "mm/yyyy",
            startView: "months",
            minViewMode: "months",
            autoclose: true,
            clearBtn: true,
            orientation: "bottom"
        });

        var input = $("#invoice-due-by-search_manual");

        if (input.data('datepicker')) {
            input.datepicker('remove');
        }

        input.datepicker({
            format: "mm/dd/yyyy",
            autoclose: true,
            clearBtn: true,
            orientation: "bottom"
        });

        var input = $("#invoice-flight-dates-search_manual");

        if (input.data('daterangepicker')) {
            input.data('daterangepicker').remove();
        }

        input.daterangepicker({
            "showWeekNumbers": true,
            "autoApply": true,
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');

        $('#invoice-created-at-search_manual').daterangepicker({
            "showWeekNumbers": true,
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');


        if(variable === true)
            $('#search_invoices_manual').submit();
        hide_loader();
    };


               var  app_invoices_table = $('#app-invoices-table').DataTable({
                     columns: [
                         {data: 'order'},
                         {data: 'reconciliation_number'},
                         {data: 'invoice_id'},
                         {data: 'order_id'},
                         {data: 'status'},
                         {data: 'advertiser_name'},
                         {data: 'station'},
                         {data: 'created_at'},
                         {data: 'id'}

                     ],
                    order: [ 0, "asc" ],
                     destroy: true,
                     "columnDefs": [
                         {
                             "targets": 0,
                             "visible": false,
                             "searchable": false,
                         },
                         {
                         "targets": 7,
                         "createdCell": function (td, cellData, rowData, row, col) {
                             var date = moment(cellData);
                             html = '';
                             html = date.format('MM/DD/YY hh:mm:ss a');

                             $(td).html(html);
                         }
                     },
                         {
                             "targets": 8,
                             "orderable": false,
                             "createdCell": function (td, cellData, rowData, row, col) {
                                 console.log(cellData);
                                 /*html = '<div class="row text-center">' +
                                     ' <div class="btn-group" role="group"> <input  type="button"  onclick="probando('+cellData+')" value="Print" id="print_reconciliation"  class="btn btn-success btn-sm print_ reconciliation"  data-id=" '+cellData+'" > ' +

                                 '</div>';*/

                                 var html = '<div class="row text-center">' +
                                     ' <div class="btn-group" role="group"> ' +
                                     '<button   id="print_reconciliation_manual"  class="btn btn-success btn-sm print_reconciliation_standar"  data-id=" '+cellData+'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n' +
                                     '                                                    <i class="fa fa-print fa-fw"></i>    Reports ' +
                                     '                                                    <span class="caret"></span>' +
                                     '                                                    <span class="sr-only">Toggle Dropdown</span>' +
                                     '</button> ' ;
                                 html+= ' <ul class="dropdown-menu dropdown-menu-right "  style="overflow:visible;z-index: 9999; position: relative"> ' +
                                     '<li> <a href="#" class="print_rec" data-id=" '+cellData+'">Invoice-Schedule Matching</a></li>' ;

                                 html+= '<li> <a href="#" class="weekly_breakout_standar" data-id=" '+cellData+'" >Weekly Breakout Report</a></li>' ;

                                 html+= '<li> <a href="#" class="rotation_analysis_standar" data-id=" '+cellData+'" >Rotation Analysis</a></li>' ;

                                 html+= '<li> <a href="#" class="spot_rotation_standar" data-id=" '+cellData+'" >Spot Pattern </a></li>' +
                                     ' </ul> ';

                                 html+= '</div>';
                                 $(td).html(html);
                             }
                         }
                     ],
                     "createdRow": function (row, data, dataIndex) {
                         $(row).attr('data-invoice-id', data.id);
                     }

                 });

    var  app_manual_invoices_table = $('#app-manual-invoices-table').DataTable({
        columns: [
            {data: 'order'},
            {data: 'rec_number'},
            {data: 'invoice_id'},
            {data: 'order_id'},
            {data: 'advertiser_name'},
            {data: 'station'},
            {data: 'created_at'},
            {data: 'id'}

        ],
        order: [ 0, "asc" ],
        destroy: true,
        "columnDefs": [
            {
                "targets": 0,
                "visible": false,
                "searchable": false,
            },
            {
                "targets": 6,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var date = moment(cellData);
                    html = '';
                    html = date.format('MM/DD/YY hh:mm:ss a');

                    $(td).html(html);
                }
            },
            {
                "targets": 7,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log(cellData);
                    console.log(rowData);
                   var html = '<div class="row text-center">' +
                        ' <div class="btn-group" role="group"> ' +
                        '<button   id="print_reconciliation_manual"  class="btn btn-success btn-sm print_ reconciliation_manual"  data-id=" '+cellData+'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n' +
                        '                                                    <i class="fa fa-print fa-fw"></i>    Reports ' +
                        '                                                    <span class="caret"></span>' +
                        '                                                    <span class="sr-only">Toggle Dropdown</span>' +
                        '</button> ' ;
                    html+= ' <ul class="dropdown-menu dropdown-menu-right "  style="overflow:visible;z-index: 9999; position: relative"> ' +
                           '<li> <a href="#" class="print_rec_manual" data-id=" '+cellData+'">Invoice-Schedule Matching</a></li>' ;

                    html+= '<li> <a href="#" class="weekly_breakout" data-id=" '+cellData+'" >Weekly Breakout Report</a></li>' ;

                    html+= '<li> <a href="#" class="rotation_analysis_manual" data-id=" '+cellData+'" >Rotation Analysis</a></li>' ;

                    html+= '<li> <a href="#" class="spot_rotation_manual" data-id=" '+cellData+'" >Spot Pattern </a></li>' +
                        ' </ul> ';

                       html+= '</div>';
                    $(td).html(html);
                }
            }
        ],
        "createdRow": function (row, data, dataIndex) {
            $(row).attr('data-invoice-id', data.id);
        }

    });



    var modal = $('#invoice_display');
    modal.on('show.bs.modal', function () {
        var closeModalBtns = modal.find('button[data-custom-dismiss="modal"]');
        closeModalBtns.one('click', function () {
            modal.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (evt) {
                modal.modal('hide');
            });
            modal.removeClass('slideInUp').addClass('slideOutDown');
        })
    });

    modal.on('hide.bs.modal', function (evt) {
        var closeModalBtns = modal.find('button[data-custom-dismiss="modal"]');
        modal.removeClass('slideOutDown');
        modal.off('webkitAnimationEnd oanimationend msAnimationEnd animationend')
        closeModalBtns.off('click');
    });

    var modal1 = $('#searchOrdenToMach');
    modal1.on('show.bs.modal', function () {
        var closeModalBtns = modal1.find('button[data-custom-dismiss="modal"]');
        closeModalBtns.one('click', function () {
            modal1.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (evt) {
                modal1.modal('hide');
            });
            modal1.removeClass('slideInUp').addClass('slideOutDown');
        })
    });

    modal1.on('hide.bs.modal', function (evt) {
        var closeModalBtns = modal1.find('button[data-custom-dismiss="modal"]');
        modal1.removeClass('slideOutDown');
        modal1.off('webkitAnimationEnd oanimationend msAnimationEnd animationend')
        closeModalBtns.off('click');
    });


    //reports
    $('#app-invoices-table').on('click', '.print_rec', function () {
       var id=  $(this).attr('data-id');
       var link = document.createElement('a');
       link.href = "/invoices/reconciliation/"+ id +"/download";
       $(link).attr('target', '_blank');
       link.click();
   });
    $('#app-invoices-table').on('click', '.weekly_breakout_standar', function () {
        var id=  $(this).attr('data-id');
        var link = document.createElement('a');
        link.href = "/invoices/reconciliation/weekly_report/"+ id +"/download";
        $(link).attr('target', '_blank');
        link.click();
    });

    //var print_rec_manual = function (id) {
    $('#app-manual-invoices-table').on('click', '.print_rec_manual', function () {
        var id=  $(this).attr('data-id');
        var link = document.createElement('a');
        link.href = "/invoices/manual/reconciliation/"+ id +"/download";
        $(link).attr('target', '_blank');
        link.click();
    });

    $('#app-manual-invoices-table').on('click', '.weekly_breakout', function () {
        var id=  $(this).attr('data-id');
        var link = document.createElement('a');
        link.href = "/invoices/manual/reconciliation/weekly_report/"+ id +"/download";
        $(link).attr('target', '_blank');
        link.click();
    });
    $('#app-manual-invoices-table').on('click', '.rotation_analysis_manual', function () {
        $('#rec_manual').val($(this).attr('data-id'));
        $('#InvoiceRotationAnalysisManual').modal('show');
    });
    $('#app-invoices-table').on('click', '.rotation_analysis_standar', function () {
        $('#rec_standar').val($(this).attr('data-id'));
        $('#InvoiceRotationAnalysisStandar').modal('show');
    });
    var columnOrderDetails = [
        {
            headerName: "Order Line",
            field: 'line',
            width: 100,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Start Time",
            field: 'start_time',
            width: 150,
            cellStyle: {'text-align': "right"}
        },  {
            headerName: "End Time",
            field: 'end_time',
            width: 150,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Days",
            field: 'days',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Spot Matched",
            field: 'spot_matches',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Line Id",
            field: 'line_id',
            width: 100,
            hide: true,
            cellStyle: {'text-align': "right" }
        },

    ];

    var orderLinesSpotRotGrid = {
        columnDefs: columnOrderDetails,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        }
    };
    $('#app-manual-invoices-table').on('click', '.spot_rotation_manual', function () {
        show_loader();
        var rec_id= $(this).attr('data-id');
        var type= 'manual';
        $.ajax({
            type: 'GET',
            url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var lines=[];
                $('#rec_number').val(rec_id);
                $('#rec_type').val('manual');

                $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' +data.camp.name);
                $('#InfoOrder').html('<b>Order No: </b> ' + '  ' +data.order.reference_number);
                $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ' +data.invoice.invoice_num);
                $('#InfoStation').html('<b>Station: </b> ' + '  ' +data.station.name);
                for(var ind in data.lines) {
                    var row = {
                        line_id: data.lines[ind]['id'],
                        line: data.lines[ind]['order_line'],
                        start_time: data.lines[ind]['start_time'],
                        end_time: data.lines[ind]['end_time'],
                        days: data.lines[ind]['days'],
                        spot_matches: data.lines[ind]['spot'],
                    }
                    lines.push(row);
                }
                $('#orderLinesSpotRotGridGrid').html('');
                orderLinesSpotRotGrid.rowData = lines;
                var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);
                hide_loader();
                $('#OrderLinesSpot').modal('show');

            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });


    });
    $('#app-invoices-table').on('click', '.spot_rotation_standar', function () {
        show_loader();
        var rec_id= $(this).attr('data-id');
        var type= 'imported';
        $('#rec_number').val(rec_id);
        $('#rec_type').val(type);
        $.ajax({
            type: 'GET',
            url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#rec_number').val(rec_id);
                $('#rec_type').val('imported');
                $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' +data.camp.name);
                $('#InfoOrder').html('<b>Order No: </b> ' + '  ' +data.order.reference_number);
                $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ' +data.invoice.invoice_number);
                $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station.name);
                var lines=[];
                for(var ind in data.lines) {
                    var row = {
                        line_id: data.lines[ind]['id'],
                        line: data.lines[ind]['id'],
                        start_time: data.lines[ind]['start_time'],
                        end_time: data.lines[ind]['end_time'],
                        days: data.lines[ind]['days'],
                        spot_matches: data.lines[ind]['spot'],
                    }
                    lines.push(row);
                }
                $('#orderLinesSpotRotGridGrid').html('');
                orderLinesSpotRotGrid.rowData = lines;
                var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);
                hide_loader();
                $('#OrderLinesSpot').modal('show');

            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });


    });
    $('#spot_rotation_create').on('click', function(){
        var sell= orderLinesSpotRotGrid.api.getSelectedNodes();
        if(sell.length > 0) {
         console.log($('#rec_number').val());
         console.log(sell[0].data.line);
         console.log($('#rec_type').val());

            var link = document.createElement('a');
            link.href = '/invoices/reconciliation/spotRotationGraphTwo/' + $('#rec_number').val()+ '/' + sell[0].data.line+ '/' + $('#rec_type').val()+ '/download';
            console.log(link.href);
            $(link).attr('target', '_blank');
            link.click();

        }
        else{
            global_notification('warning', 'Please select a line first ...');
        }

    });



    $('#send_rotation_analysis_standar').on('click', function () {
        var invoice=  'imported'+ $('#rec_standar').val();
        var separation= $('#separation').val();
        var flag='';
        $('.option_rotation_check input[type=checkbox]').each(function () {
            if($(this).prop('checked')== true){
                if(flag=='') {
                    if ($(this).val() == 'horizontal')
                        flag = 'horitonzal';
                    else
                        flag = 'vertical';
                }
                else{
                    if ($(this).val() == 'horizontal')
                        flag += '_horitonzal';
                    else
                        flag += '_vertical';
                }
            }
        });
            if(flag!='') {
                if(separation =='' )
                    global_notification('warning', 'Please type a separation minutes for spots...');
                else {
                    var link = document.createElement('a');
                    link.href = '/download/invoices/rotation_analysis/min/' + separation + '/options/' + flag + '/inv/' + invoice + '/download';
                    $(link).attr('target', '_blank');
                    link.click();
                }
            }
            else global_notification('warning', 'Please check at least one flag option...');

    });
    $('#send_rotation_analysis_manual').on('click', function () {
        var invoice=  'manual'+ $('#rec_manual').val();
        var separation= $('#separationmanual').val();
        var flag='';
        $('.option_rotation_check_manual input[type=checkbox]').each(function () {
            if($(this).prop('checked')== true){
                if(flag=='') {
                    if ($(this).val() == 'horizontal')
                        flag = 'horitonzal';
                    else
                        flag = 'vertical';
                }
                else{
                    if ($(this).val() == 'horizontal')
                        flag += '_horitonzal';
                    else
                        flag += '_vertical';
                }
            }
        });
        if(flag!='') {
            var link = document.createElement('a');
            link.href = '/download/invoices/rotation_analysis/min/' + separation + '/options/' + flag +'/inv/' + invoice + '/download';
            $(link).attr('target', '_blank');
            link.click();
        }
        else global_notification('warning', 'Please check at least one flag option...');

    });

    function getDays(value){
        var res = "";
        if(value['m'])
            res += "M";
        else
            res += '-';
        if(value['t'])
            res += "T";
        else
            res += '-';
        if(value['w'])
            res += "W";
        else
            res += '-';
        if(value['r'])
            res += "R";
        else
            res += '-';
        if(value['f'])
            res += "F";
        else
            res += '-';
        if(value['s'])
            res += "S";
        else
            res += '-';
        if(value['u'])
            res += "U";
        else
            res += '-';
        return res;
    }

    $("#match-invoice-order").on("click", function(e){
        var sel = $("input:radio[name=sel_order]:checked").attr('id');
        if(typeof sel !== 'undefined') {
            show_overlay_loader('#searchOrdenToMach');
            var arr = {
                'sel': sel
            };
            console.log(arr);
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: $(this).attr('data-contact-url'),
                data: JSON.stringify(arr),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    console.log(data);
                    var html = "";
                    $('#matches').html(html);
                    var oweeks = 0;
                    var tspots = 0;
                    var mspots = 0;
                    $.each(data.olines, function (index, value) {
                        html += '<li class="dd-item" data-level="1" data-id="o_'+ index +'" start="'+value['start']+'" end="' + value['end'] + '" days="'+ getDays(value) +'" daypart="'+ value['daypart'] +'" cost="'+ value['cost'] +'" length="'+ value['length'] +'">';
                        html += '<button data-action="collapse" type="button" style="display: block;">Collapse</button><button data-action="expand" type="button" style="display: none;">Expand</button>';
                        html += '<div style="height: 35px;background-color: white;border: 1px solid #7FDBFF;color: black;" class="dd-handle">' + value['start'] + '-' + value['end'] + ' | ' + getDays(value) + '(' + value['daypart'] + ') | $' + value['cost'] + ' | ' + value['length'] + ' sec <div style="float: right">Line ('+ data.oline_spots[index] +')</div></div>';
                        html += '<ol class="dd-list" style="">';

                        $.each(data.weeks, function (windex, wvalue) {
                            html += '<li class="dd-item" data-level="2" data-id="w_'+ windex +'" start="'+ wvalue['start'] +'" end="'+ wvalue['end'] +'" maxc="'+ data.weeks_totals[index][windex] +'">';
                            if (typeof data.match[index] !== 'undefined') {
                                if(typeof data.match[index][windex] !== 'undefined') {
                                    if(data.match[index][windex].length !== 0) {
                                        html += '<button data-action="collapse" type="button" style="display: block;">Collapse</button><button data-action="expand" type="button" style="display: none;">Expand</button>';
                                        html += '<div style="height: 35px;background-color: white;color: black;border: 1px solid black;" class="dd-handle" scount="'+ data.match[index][windex].length +'">' + wvalue['start'] + ' - ' + wvalue['end'] + ' <div style="float: right">Week ('+ data.match[index][windex].length +' of '+ data.weeks_totals[index][windex] +')</div></div>';
                                        html += '<ol class="dd-list" style="">';
                                        $.each(data.match[index][windex], function (index1, value1) {
                                            html += '<li spot-error="false" data-level="3" class="dd-item" data-id="b_' + value1['id'] + '" day_of_week="'+ value1['day_of_week'] +'" run_date="'+ value1['run_date'] +'" time_of_day="'+ value1['time_of_day'] +'" type_spot_length="'+ value1['type_spot_length'] +'">';
                                            html += '<div style="height: 30px;background-color: white;border: 1px solid #FF851B;color: black;" class="dd-handle">' + value1['day_of_week'] + ' | ' + value1['run_date'] + ' | ' + value1['time_of_day'] + ' | ' + value1['type_spot_length'] + ' sec <div style="float: right">Spot</div></div>';
                                            html += '</li>';
                                        });
                                        mspots += data.match[index][windex].length;
                                        html += '</ol>';
                                    }else{
                                        html += '<div style="height: 35px;background-color: white;color: black;border: 1px solid black;" class="dd-handle" scount="0">'+ wvalue['start'] +' - '+ wvalue['end'] +' <div style="float: right">Week (0 of '+ data.weeks_totals[index][windex] +')</div></div>';
                                    }
                                }else{
                                    html += '<div style="height: 35px;background-color: white;color: black;border: 1px solid black;" class="dd-handle" scount="0">'+ wvalue['start'] +' - '+ wvalue['end'] +' <div style="float: right">Week (0 of '+ data.weeks_totals[index][windex] +')</div></div>';
                                }

                            } else {
                                html += '<div style="height: 35px;background-color: white;color: black;border: 1px solid black;" class="dd-handle" scount="0">'+ wvalue['start'] +' - '+ wvalue['end'] +' <div style="float: right">Week (0 of '+ data.weeks_totals[index][windex] +')</div></div>';
                            }
                            tspots += data.weeks_totals[index][windex];
                            html += '</li>';
                        });
                        //html += '<div class="dd-handle">' + value['start'] + '-' + value['end'] + ' | ' + getDays(value) + '(' + value['daypart'] + ') | $' + value['cost'] + ' | ' + value['length'] + ' sec</div>';

                        //html += '<div class="dd-handle">' + value['start'] + '-' + value['end'] + ' | ' + getDays(value) + '(' + value['daypart'] + ') | $' + value['cost'] + ' | ' + value['length'] + ' sec</div>';

                        html += '</ol>';
                        html += '</li>';
                    });
                    $('#matches').html(html);
                    $("#tspots").html(tspots);
                    $("#mspots").html(mspots);
                    $("#lspots").html(tspots - mspots);
                    $("#oweeks").html(oweeks);

                    html = '';
                    $('#no_matches').html(html);
                    $.each(data.no_match, function (index, value) {
                        html += '<li spot-error="false" data-level="3" class="dd-item" data-id="b_'+ index +'" day_of_week="'+ value['day_of_week'] +'" run_date="'+ value['run_date'] +'" time_of_day="'+ value['time_of_day'] +'" type_spot_length="'+ value['type_spot_length'] +'">';
                        html += '<div style="height: 30px;background-color: white;border: 1px solid #FF851B;color: black;" class="dd-handle">'+ value['day_of_week'] +' | '+ value['run_date'] +' | '+ value['time_of_day'] +' | '+ value['type_spot_length'] +' sec <div style="float: right">Spot</div></div>';
                        html += '</li>';
                    });
                    $('#no_matches').html(html);
                    $("#uspots").html(data.no_match.length);

                    var aux = null;
                    $('.dd').nestable({
                        onDragStart: function(l,e){
                            if($(e).attr('data-level') == 3) {
                                aux = $(e).parent();
                                console.log("off");
                                console.log(aux);
                                var chlds = $(aux).parent().children();
                                var c = 0;
                                if (chlds.length === 4) {
                                    console.log("first");
                                    c = $(chlds[2]).attr('scount');
                                    console.log("c: " + c);
                                    if(parseInt(c) >= 1){
                                        console.log("first1");
                                        $(chlds[2]).attr('scount', parseInt(c) - 1);
                                        var week = $(chlds[2]).children();
                                        console.log("week");
                                        console.log(week);
                                        var arr = $(week[0]).html().split('(');
                                        var arr1 = arr[1].split('of');
                                        var res = arr[0] + "(" + (parseInt(c)-1) + " of " + arr1[1];
                                        $(week).html(res);
                                    }
                                    //console.log("---------------------------: " + c + " - " + arr1[1]);
                                    if(parseInt(c)-1 === parseInt($(chlds[2]).parent().attr('maxc'))){
                                        var oweeks = parseInt($("#oweeks").html());
                                        if(oweeks > 0)
                                            $("#oweeks").html(oweeks - 1);
                                    }
                                    var wspots = parseInt($("#lspots").html());
                                    var mspots = parseInt($("#mspots").html());
                                    $("#lspots").html(wspots + 1);
                                    if(mspots > 0)
                                        $("#mspots").html(mspots - 1);
                                    if($(e).attr('spot-error') === 'true'){
                                        var espots = parseInt($("#espots").html());
                                        if(espots > 0)
                                            $("#espots").html(espots - 1);
                                        // $(e).attr('spot-error', 'false');
                                    }
                                }else{
                                    console.log("second");
                                    c = $(chlds[0]).attr('scount');
                                    $(chlds[0]).attr('scount', parseInt(c) - 1);
                                    var week = $(chlds[0]).children();
                                    var arr = $(week[0]).html().split('(');
                                    if(typeof arr[1] !== 'undefined') {
                                        console.log("second1");
                                        var arr1 = arr[1].split('of');
                                        var res = arr[0] + "(" + (parseInt(c) - 1) + " of " + arr1[1];
                                        console.log("---------------------------: " + c + " - " + arr1[1]);
                                        if(parseInt(c)-1 === parseInt(arr1[1])){
                                            var oweeks = parseInt($("#oweeks").html());
                                            if(oweeks > 0)
                                                $("#oweeks").html(oweeks - 1);
                                        }
                                        $(week).html(res);
                                    }
                                    var uspots = parseInt($("#uspots").html());
                                    if($(e).attr('data-id') !== "b_newline") {
                                        $("#uspots").html(uspots - 1);
                                        //alert($(e).css('border-color'));
                                    }
                                }
                                return true;
                            }
                            global_notification('warning', "Only broadcast line can be moved...");
                            return false;
                            // l is the main container
                            // e is the element that was moved
                        },
                        beforeDragStop: function(l,e, p){
                            if($(p).parent().attr('data-level') == 2 || $(p).attr('id') === "no_matches") {

                                if($(p).parent().attr('data-level') == 2) {
                                    var chlds = $(p).parent().children();
                                    var c = 0;
                                    if (chlds.length === 4) {
                                        c = $(chlds[2]).attr('scount');
                                    } else {
                                        c = $(chlds[0]).attr('scount');
                                    }
                                    var week = $(p).parent();
                                    var start = $(week).attr("start");
                                    start = moment(start.split(" ")[0], "YYYY-MM-DD");
                                    var end = $(week).attr("end");
                                    end = moment(end.split(" ")[0], "YYYY-MM-DD");
                                    var rundate = moment($(e).attr("run_date"), "YYYY-MM-DD");
                                    var conf1 = false;
                                    if(rundate.isBefore(start) || rundate.isAfter(end)){
                                        conf1 = confirm("Spot Run-Date does not match with selected week. Do you still want to move the broadcast line?");
                                        if(conf1){
                                            var espots = parseInt($("#espots").html());
                                            $("#espots").html(espots + 1);
                                            $(e).attr('spot-error', 'true');
                                        }
                                    }else{
                                        conf1 = true;
                                    }
                                    if(!conf1) {
                                        console.log("1212121212");
                                        console.log($(e).attr('spot-error'));
                                        if($(e).attr('spot-error') === 'true') {
                                            if (chlds.length === 4) {
                                                console.log("1313131313");
                                                $(chlds[2]).attr('scount', parseInt(c) + 1);
                                                var week = $(chlds[2]).children();
                                                var arr = $(week).html().split('(');
                                                var arr1 = arr[1].split('of');
                                                var res = arr[0] + "(" + (parseInt(c) + 1) + " of " + arr1[1];
                                                $(week).html(res);
                                                var lspots = parseInt($("#lspots").html());
                                                var mspots = parseInt($("#mspots").html());
                                                if (lspots > 0)
                                                    $("#lspots").html(lspots - 1);
                                                $("#mspots").html(mspots + 1);
                                            } else {
                                                console.log("141414141414");
                                                $(chlds[0]).attr('scount', parseInt(c) + 1);
                                                var week = $(chlds[0]).children();
                                                var arr = $(week).html().split('(');
                                                var arr1 = arr[1].split('of');
                                                var res = arr[0] + "(" + (parseInt(c) + 1) + " of " + arr1[1];
                                                $(week).html(res);
                                                var lspots = parseInt($("#lspots").html());
                                                var mspots = parseInt($("#mspots").html());
                                                if (lspots > 0)
                                                    $("#lspots").html(lspots - 1);
                                                $("#mspots").html(mspots + 1);
                                            }
                                            var espots = parseInt($("#espots").html());
                                            $("#espots").html(espots + 1);
                                        }
                                        if(parseInt(c) === parseInt($(p).parent().attr('maxc'))){
                                            var oweeks = parseInt($("#oweeks").html());
                                            $("#oweeks").html(oweeks + 1);
                                        }
                                        return false;

                                    }
                                    var line = $(week).parent().parent();
                                    conf1 = false;
                                    var dayofweek = $(e).attr("day_of_week");
                                    console.log(dayofweek + " ---- " + $(line).attr("days"));
                                    if(!$(line).attr("days").includes(dayofweek)){
                                        conf1 = confirm("Day of the week does not match with avail line. Do you still want to move the broadcast line?");
                                        if(conf1 && $(e).attr('spot-error') !== 'true'){
                                            var espots = parseInt($("#espots").html());
                                            $("#espots").html(espots + 1);
                                            $(e).attr('spot-error', 'true');
                                        }
                                    }else{
                                        conf1 = true;
                                    }
                                    if(!conf1) {
                                        console.log("1212121212");
                                        console.log($(e).attr('spot-error'));
                                        if($(e).attr('spot-error') === 'true') {
                                            if (chlds.length === 4) {
                                                console.log("131313131313");
                                                $(chlds[2]).attr('scount', parseInt(c) + 1);
                                                var week = $(chlds[2]).children();
                                                var arr = $(week).html().split('(');
                                                var arr1 = arr[1].split('of');
                                                var res = arr[0] + "(" + (parseInt(c) + 1) + " of " + arr1[1];
                                                $(week).html(res);
                                                var lspots = parseInt($("#lspots").html());
                                                var mspots = parseInt($("#mspots").html());
                                                if (lspots > 0)
                                                    $("#lspots").html(lspots - 1);
                                                $("#mspots").html(mspots + 1);
                                            } else {
                                                console.log("141414141414");
                                                $(chlds[0]).attr('scount', parseInt(c) + 1);
                                                var week = $(chlds[0]).children();
                                                var arr = $(week).html().split('(');
                                                var arr1 = arr[1].split('of');
                                                var res = arr[0] + "(" + (parseInt(c) + 1) + " of " + arr1[1];
                                                $(week).html(res);
                                                var lspots = parseInt($("#lspots").html());
                                                var mspots = parseInt($("#mspots").html());
                                                if (lspots > 0)
                                                    $("#lspots").html(lspots - 1);
                                                $("#mspots").html(mspots + 1);
                                            }
                                            var espots = parseInt($("#espots").html());
                                            $("#espots").html(espots + 1);
                                        }
                                        if(parseInt(c) === parseInt($(p).parent().attr('maxc'))){
                                            var oweeks = parseInt($("#oweeks").html());
                                            $("#oweeks").html(oweeks + 1);
                                        }
                                        return false;
                                    }
                                    var conf = false;
                                    console.log("c: " + c);
                                    console.log("max: " + $(p).parent().attr('maxc'));
                                    if (c + 1 > $(p).parent().attr('maxc')) {
                                        global_notification('warning', "The week from order line is completed. Try in other week..");
                                        var conf = confirm("This week is full.Do you still want to move the broadcast line?");
                                        if(conf && parseInt(c) === parseInt($(p).parent().attr('maxc'))){
                                            var oweeks = parseInt($("#oweeks").html());
                                            $("#oweeks").html(oweeks + 1);
                                        }
                                    }else{
                                        conf = true;
                                    }
                                    if (!conf) {
                                        if(parseInt(c) === parseInt($(p).parent().attr('maxc'))){
                                            var oweeks = parseInt($("#oweeks").html());
                                            $("#oweeks").html(oweeks + 1);
                                        }
                                        return false;
                                    }else{
                                        if (chlds.length === 4) {
                                            $(chlds[2]).attr('scount', parseInt(c) + 1);
                                            var week = $(chlds[2]).children();
                                            var arr = $(week).html().split('(');
                                            var arr1 = arr[1].split('of');
                                            var res = arr[0] + "(" + (parseInt(c)+1) + " of " + arr1[1];
                                            $(week).html(res);
                                            var lspots = parseInt($("#lspots").html());
                                            var mspots = parseInt($("#mspots").html());
                                            if(lspots > 0)
                                                $("#lspots").html(lspots - 1);
                                            $("#mspots").html(mspots + 1);
                                        } else {
                                            $(chlds[0]).attr('scount', parseInt(c) + 1);
                                            var week = $(chlds[0]).children();
                                            var arr = $(week).html().split('(');
                                            var arr1 = arr[1].split('of');
                                            var res = arr[0] + "(" + (parseInt(c)+1) + " of " + arr1[1];
                                            $(week).html(res);
                                            var lspots = parseInt($("#lspots").html());
                                            var mspots = parseInt($("#mspots").html());
                                            if(lspots > 0)
                                                $("#lspots").html(lspots - 1);
                                            $("#mspots").html(mspots + 1);
                                        }
                                    }
                                }else{
                                    console.log("aux");
                                    console.log(aux);
                                    var chlds = $(aux).parent().children();
                                    if (chlds.length === 4) {
                                        console.log("11111111");
                                        c = $(chlds[2]).attr('scount');
                                        $(chlds[2]).attr('scount', parseInt(c) - 1);
                                        var week = $(chlds[2]).children();
                                        var arr = $(week[0]).html().split('(');
                                        var arr1 = arr[1].split('of');
                                        var res = arr[0] + "(" + (parseInt(c)-1) + " of " + arr1[1];
                                        $(week).html(res);
                                        var uspots = parseInt($("#uspots").html());
                                        if($(e).attr('data-id') !== "b_newline") {
                                            $("#uspots").html(uspots + 1);
                                            //console.log($(e));
                                        }
                                    } else {
                                        console.log("22222222222");
                                        c = $(chlds[0]).attr('scount');
                                        $(chlds[0]).attr('scount', parseInt(c) - 1);
                                        var week = $(chlds[0]).children();
                                        if(typeof $(week[0]).html() !== 'undefined') {
                                            console.log("3333333333333");
                                            var arr = $(week[0]).html().split('(');
                                            if(typeof arr[1] !== 'undefined') {
                                                console.log("444444444");
                                                var arr1 = arr[1].split('of');
                                                var res = arr[0] + "(" + (parseInt(c) - 1) + " of " + arr1[1];
                                                $(week).html(res);
                                            }
                                            var uspots = parseInt($("#uspots").html());
                                            if($(e).attr('data-id') !== "b_newline") {
                                                $("#uspots").html(uspots + 1);
                                                //console.log($(e));
                                            }
                                        }else{
                                           // console.log("adasdasdasdasd");
                                        }
                                    }
                                }
                                return true;
                            }
                            global_notification('warning', "Broadcast lines only can me moved to weeks or No-match section...");
                            return false;
                        }
                    });
                    $("#saveMachtModal").modal('show');
                    hide_overlay_loader('#searchOrdenToMach');
                },
                error: function (xhr) {
                    hide_overlay_loader('#searchOrdenToMach');
                    console.log(xhr);
                    if (xhr.status === 422) {
                        global_notification('warning', xhr.responseJSON.message);
                    }
                    else if (xhr.status === 504) {
                        global_notification('warning', "Sorry our server is running a little slow at the moment.");
                    }
                    else {
                        ajax_error();
                        debug(xhr.responseText);
                    }
                }
            });
        }
    });
    var list = $('#EditRules');


    $("#match-invoice-order").on("click", function (e) {
        var arr = {
            'sel': $("input:radio[name=sel_order]:checked").attr('id')
        };
        console.log(arr);
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: $(this).attr('data-contact-url'),
            data: JSON.stringify(arr),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {

            },
            error: function (xhr) {
                console.log(xhr);
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                }
                else if (xhr.status === 504) {
                    global_notification('warning', "Sorry our server is running a little slow at the moment.");
                }
                else {
                    ajax_error();
                    debug(xhr.responseText);
                }
            }
        });
    });

    $('#search_invoices_manual').on('submit', function (e) {
        e.preventDefault();
        show_loader();

        var data = $(this).serializeArray();

        $.ajax({
            type: 'GET',
            url: '/invoices/manual/reconciliation/index',
            data: data,
            dataType: 'json',
            encode: true,
            success: function (data) {

                if (data.length === 0) {
                    global_notification('warning', 'No Reconciliations were returned matching your parameters. Please try to expand your parameters.');
                }
                console.log(data);

                app_manual_invoices_table.clear();
                app_manual_invoices_table.rows.add(data);
                app_manual_invoices_table.draw();

                hide_loader();
            },
            error: function(xhr){
                debug(xhr.responseText);
                hide_loader();
            }
        });
    });

    $('#search_invoices').on('submit', function (e) {
        e.preventDefault();

        show_loader();

        var data = $(this).serializeArray();

        $.ajax({
            type: 'GET',
            url: '/invoices/reconciliation/index',
            data: data,
            dataType: 'json',
            encode: true,
            success: function (data) {

                if (data.length === 0) {
                    global_notification('warning', 'No Reconciliations were returned matching your parameters. Please try to expand your parameters.');
                }
                console.log(data);

                app_invoices_table.clear();
                app_invoices_table.rows.add(data);
                app_invoices_table.draw();


                $('.order-button-search').on('click', function (event) {
                    event.stopPropagation();

                    show_loader();
                    var id = $(this).parent().parent().parent().parent().attr('data-invoice-id');

                    $.ajax({
                        type: 'GET',
                        url: '/invoices/orders/' + id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            //modal1.find('.modal-body').html(data.view);
                            console.log("reconciliationjs");
                            console.log(data);
                            html = "";
                            if(data.orders.length > 0){
                                $.each(data.orders, function(index, value){
                                    html += "<tr>";
                                    html += "<td> Order (#"+ value['reference_number'] +") </td>";
                                    html += "<td></td>";
                                    html += "<td></td>";
                                    html += "<td></td>";
                                    html += "<td></td>";
                                    html += "<td></td>";
                                    html += "<td></td>";
                                    html += "</tr>";
                                    $.each(data.ordersr[value['id']], function(index1, value1){
                                        html += "<tr>";
                                        html += "<td><div class='radio radio-primary'>" +
                                            "<input type='radio' name='sel_order' id='sel_order_"+ value1['id'] +"_"+ id +"'><label for='sel_order_"+ value1['id'] +"_"+ id +"'> </label></div></td>";
                                        html += "<td>"+ data.camps[index]['name'] +"</td>";
                                        html += "<td>"+ "(" + ((data.versions[index]['name'] != null) ? data.versions[index]['name'] : "Worksheet") + ") #" + data.versions[index]['number'] +"</td>";
                                        html += "<td>"+ value['vendor']['name'] +"</td>";
                                        html += "<td>"+ value1['created_at'] +"</td>";
                                        html += "<td>"+ value1['updated_at'] +"</td>";
                                        html += "<td></td>";
                                        html += "</tr>";
                                    });
                                });
                            }

                            modal1.find('tbody').html(html);
                            modal1.addClass('slideInUp');
                            modal1.modal('show');
                        },
                        error: function (xhr) {
                            console.log(xhr);
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            }
                            else if (xhr.status === 504) {
                                global_notification('warning', "Sorry our server is running a little slow at the moment.");
                            }
                            else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        }
                    });
                    hide_loader();

                });


                $('.edit_rulesok').on('click', function (event1) {
                    event1.stopPropagation();


                    show_loader();
                    var id = $(this).parent().parent().parent().parent().attr('data-invoice-id');
                    $('#id_invoice_hidden').val(id);

                    $.ajax({
                        type: 'GET',
                        url: '/invoices/rules/' + id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            html = "";

                            if(typeof data.rules != 'undefined'){
                                html += " <tr>";
                                html += '<td><div class="checkbox checkbox-danger">' +
                                    ' <input id="rule1" name="rules[]" checked="" type="checkbox" value="run">' +
                                    ' <label for="rule1">Ran</label></div></td>' +
                                    ' <td><div class="checkbox checkbox-danger"> ' +
                                    ' <input  name="rules[]" id="rule2" checked="" type="checkbox" value="station"> ' +
                                    ' <label for="rule2">Station</label> </div> </td>' +
                                    ' <td><div class="checkbox checkbox-danger">" ' +
                                    ' <input type="checkbox" name="rules[]" id="rule3" checked="" value="network"> ' +
                                    '<label for="rule3">Network</label> </div></td> ' +
                                    '  </tr> ';

                                html += "<tr>";

                                html += "<td> <div class='checkbox checkbox-danger'>" +
                                    "<input type='checkbox' name='rules[]' id='rule4' checked='' value='week'> " +
                                    " <label for='rule4'>Week</label>" +
                                    "</div></td>" +
                                    "<td> <div class='checkbox checkbox-danger'>" +
                                    " <input type='checkbox' name='rules[]' id='rule7' checked='' value='length'> " +
                                    "<label for='rule7'>Length</label>" +
                                    "</div></td>" +
                                    " <td><div class='checkbox checkbox-danger'>" +
                                    " <input type='checkbox' name='rules[]' id='rule8' checked='' value='cost'> " +
                                    " <label for='rule8'>Cost</label>" +
                                    " </div></td>" +
                                    "</tr>";



                                html += "<tr>";
                                html += "<td> <div class='checkbox checkbox-danger'>" +
                                    "<input type='checkbox' name='rules[]' id='rule5' checked='' value='time_period'>  " +
                                    "<label for='rule5'>Specified time period</label>" +
                                    "</div></td>" +
                                    "<td> <div class='checkbox checkbox-danger'>" +
                                    " <input type='checkbox' name='rules[]' id='rule6' checked='' value='day'> " +
                                    "<label for='rule6'>Day of the week</label> " +
                                    " </div></td>" +
                                    "<td></td>" +
                                    "</tr>";

                            }
                            list.find('tbody').html(html);


                            if(data.rules.run == 0)
                                $("#rule1").attr("checked", false);

                            if(data.rules.run_station == 0)
                                $("#rule2").attr("checked", false);


                            if(data.rules.run_network == 0)
                                $("#rule3").attr("checked", false);

                            if(data.rules.run_week == 0)
                                $("#rule4").attr("checked", false);

                            if(data.rules.run_time == 0)
                                $("#rule5").attr("checked", false);


                            if(data.rules.run_day == 0)
                                $("#rule6").attr("checked", false);

                            if(data.rules.add_length == 0)
                                $("#rule7").attr("checked", false);


                            if(data.rules.add_cost == 0)
                                $("#rule8").attr("checked", false);






                            list.modal('show');
                        },
                        error: function (xhr) {
                            ajax_error();
                        }
                    });
                    hide_loader();
                });


              /*  $('#app-invoices-table tbody').on('click', 'tr', function () {

                    show_loader();
                    var id = $(this).attr('data-invoice-id');

                    $.ajax({
                        type: 'GET',
                        url: '/invoices/' + id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            modal.find('.modal-body').html(data.view);
                            modal.addClass('slideInUp');
                            modal.modal('show');
                        },
                        error: function (xhr) {
                            ajax_error();
                        }
                    });
                    hide_loader();
                });*/
            },
            error: function (xhr) {
                console.log(xhr);
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                }
                else if (xhr.status === 504) {
                    global_notification('warning', "Sorry our server is running a little slow at the moment.");
                }
                else {
                    ajax_error();
                    debug(xhr.responseText);
                }
            }

        });

        hide_loader();
    });


}

$("#save_rules").on("click", function (e) {

    var id=  $('#id_invoice_hidden').val();

    var rules=[];

    $("input[name='rules[]']:checked").each(function(){
        rules.push($(this).val());
    });

    $.ajax({
        type: 'GET',
        url: 'invoices/updaterules/' + id + '/' + rules,
        dataType: 'json',
        encode: true,
        success: function (data) {

            global_notification('success', "Match Rules edited...");
            list.modal('hide');

        },
        error: function (xhr) {
            ajax_error();
        }
    });

    hide_loader();
});
